import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'

import type { WorkspaceUser } from '../types'

import { UserRoleAssignForm } from './UserRoleAssignForm'

type Props = {
  open: boolean
  workspaceId: number
  user: WorkspaceUser | null
  onClose: () => void
}

/** The members table's "change role" action — the access card's form in a modal. */
export const UserChangeRoleModal = ({
  open,
  workspaceId,
  user,
  onClose
}: Props) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open && user !== null}
      onCancel={onClose}
      title={t('users.modals.changeRole.title')}
      footer={null}
      destroyOnHidden
    >
      {user ? (
        <UserRoleAssignForm
          record={user}
          workspaceId={workspaceId}
          onDone={onClose}
        />
      ) : null}
    </Modal>
  )
}
